// extracted by mini-css-extract-plugin
module.exports = {"app":"zeus_api_list_app__3C3Ke"};